import { useMediaQuery } from 'react-responsive'

/**
 * A React hook imported from the npm react-responsive package: https://www.npmjs.com/package/react-responsive#with-hooks
 * @param {string} query - The media query to check. Ie. '(max-width: 768px)'
 * @returns {boolean} - Whether the media query is true or false.
 */

export const useMediaCondition = (query: string) => {
  const mediaQueryBoolean = useMediaQuery({
    query,
  })
  return mediaQueryBoolean
}
